import { render, staticRenderFns } from "./SectionEdit.vue?vue&type=template&id=389bbfdd&scoped=true"
import script from "./SectionEdit.vue?vue&type=script&lang=js"
export * from "./SectionEdit.vue?vue&type=script&lang=js"
import style0 from "./SectionEdit.vue?vue&type=style&index=0&id=389bbfdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389bbfdd",
  null
  
)

export default component.exports